
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
gsap.registerPlugin(ScrollTrigger);


let swipeOption = {
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
}

let swiper =  new Swiper('.people-slider .swiper-container', swipeOption);


document.querySelector(".people-slider .swiper-container").addEventListener(
  "mouseenter",
  () => {
    swiper.autoplay.stop();
  },
  false
);

document.querySelector(".people-slider .swiper-container").addEventListener(
  "mouseleave",
  () => {
    swiper.autoplay.start();
  },
  false
);

gsap.to('.header', { //アニメーションしたい要素を指定
  scrollTrigger: {
    trigger: '.lawyer-index-news',//アニメーションが始まるトリガーとなる要素
    start: 'center center', //アニメーションが始まる位置を指定

    onEnter: () => {
      document.querySelector("header").classList.toggle("on");
    },
    onLeaveBack: () => {
      document.querySelector("header").classList.toggle("on");
    },
  }
});


document.addEventListener(
  "DOMContentLoaded",
  () => {
    if(!document.querySelector("header").classList.contains("top-header")) document.querySelector("header").classList.add("top-header");
  },
  false
);

